import { render, staticRenderFns } from "./dlxxregister.vue?vue&type=template&id=89d6baf8&scoped=true"
import script from "./dlxxregister.vue?vue&type=script&lang=js"
export * from "./dlxxregister.vue?vue&type=script&lang=js"
import style0 from "./dlxxregister.vue?vue&type=style&index=0&id=89d6baf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d6baf8",
  null
  
)

export default component.exports